export * from './core';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/core/index.js
// module id = ../../../material/core/index.js
// module chunks = 3